import { useEffect, useRef, useState } from 'react';

interface Props {
  html: string;
  css?: string;
  minHeight?: number;
  className?: string;
}

// Náhled uloženého HTML v izolovaném iframe bez skriptů: obsah šablony nikdy
// neběží v kontextu P1. allow-same-origin je jen kvůli měření výšky.
export function SandboxHtml({ html, css = '', minHeight = 80, className }: Props) {
  const ref = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(minHeight);
  const doc = `<!doctype html><html><head><meta charset="utf-8"><base target="_blank"><style>html,body{margin:0;padding:0;background:transparent;font-family:inherit;overflow:hidden}img{max-width:100%}${css}</style></head><body>${html}</body></html>`;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => {
      try {
        const h = el.contentDocument?.body?.scrollHeight ?? 0;
        if (h > 0) setHeight(Math.max(minHeight, h));
      } catch {
        setHeight(minHeight);
      }
    };
    el.addEventListener('load', measure);
    const t = window.setTimeout(measure, 300);
    // Odpočty (.pf-cd) oživuje rodič - uvnitř sandboxu skripty neběží. Cílový
    // čas nese atribut title, stejně jako v SDK runtime.
    const pad = (n: number) => (n < 10 ? '0' + n : String(n));
    const ticks = () => {
      const els = el.contentDocument?.querySelectorAll<HTMLElement>('.pf-cd');
      if (!els?.length) return;
      els.forEach((node) => {
        const end = Date.parse(node.getAttribute('title') ?? '');
        if (!end || Number.isNaN(end)) { node.textContent = ''; return; }
        const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        node.textContent = `${Math.floor(s / 3600)}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
      });
    };
    const cd = window.setInterval(ticks, 1000);
    const t2 = window.setTimeout(ticks, 320);
    return () => {
      el.removeEventListener('load', measure);
      window.clearTimeout(t);
      window.clearTimeout(t2);
      window.clearInterval(cd);
    };
  }, [doc, minHeight]);

  return (
    <iframe
      ref={ref}
      title="Náhled"
      sandbox="allow-same-origin"
      srcDoc={doc}
      className={className}
      style={{ border: 0, width: '100%', height, display: 'block', colorScheme: 'normal' }}
    />
  );
}
